import { createContext, useContext } from "react";

export const ContentManagementContext = createContext(null);

export const ContentManagementProvider = ({ value, children }) => (
  <ContentManagementContext.Provider value={value}>
    {children}
  </ContentManagementContext.Provider>
);

export const useContentManagementContext = () => {
  const context = useContext(ContentManagementContext);
  if (!context) {
    throw new Error("useContentManagementContext must be used within a ContentManagementProvider");
  }
  return context;
};

